<script setup lang="ts">
import CookieCountDown from './CookieCountDown.vue'
const us = useUserStore()
const { auth, REACTRefresCookie } = storeToRefs(us)
const key = ref(0)
watch(REACTRefresCookie, () => {
  key.value++
})
</script>
<template>
  <CookieCountDown v-if="auth == 'Authenticated'" :key="key" />
</template>
